import { render, staticRenderFns } from "./depreCiationParameter.vue?vue&type=template&id=8017d202&scoped=true&"
import script from "./depreCiationParameter.vue?vue&type=script&lang=js&"
export * from "./depreCiationParameter.vue?vue&type=script&lang=js&"
import style0 from "./depreCiationParameter.vue?vue&type=style&index=0&id=8017d202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8017d202",
  null
  
)

export default component.exports